import React from 'react'
import PropTypes from 'prop-types'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Helmet from 'react-helmet'
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n';
import { StaticQuery, graphql } from "gatsby"
import { IntlProvider } from 'react-intl';
import 'intl';
import './index.css'
import {Container} from 'reactstrap';

const Layout = ({ children, location, i18nMessages }) => {
  return (
    <StaticQuery
      query={graphql`
        query LayoutQuery {
          site {
            siteMetadata {
              languages {
                defaultLangKey
                langs
              }
            }
          }
        }
      `}
      render={data => {
        const url = location.pathname;
        const { langs, defaultLangKey } = data.site.siteMetadata.languages;
        const langKey = getCurrentLangKey(langs, defaultLangKey, url);
        const homeLink = `/${langKey}`.replace(`/${defaultLangKey}/`, '/');
        const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url)).map((item) => ({ ...item, link: item.link.replace(`/${defaultLangKey}/`, '/') }));
        return (

          <IntlProvider
            locale={langKey}
            messages={i18nMessages}
          >
            <div className="layout">
              <Helmet
                title="Title"
                meta={[
                  { name: 'description', content: 'Sample' },
                  { name: 'keywords', content: 'sample, something' },
                ]}
              />
              <Header langs={langsMenu} languag={langKey}/>
              <Container fluid className="flex-grow px-0">
              {children}
              </Container>

              <Footer location={langKey} />
              <script type="text/javascript" charset="UTF-8" src="//cdn.cookie-script.com/s/4aeb56e77595daecea8d717b695e0373.js"></script>
            </div>
          </IntlProvider>

        )
      }}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout
